import React from 'react';
import { AppWindow } from 'lucide-react';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';
const FONT_DISPLAY = "'Fraunces', Georgia, serif";
const FONT_SANS    = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function CompanyInfo() {
  const currentYear = new Date().getFullYear();

  return (
    <div style={{ fontFamily: FONT_SANS }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '16px'
      }}>
        Company Information
      </h3>

      <div style={{
        padding: '20px',
        background: PAPER,
        borderRadius: '12px',
        border: '1px solid rgba(139,69,19,0.1)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '20px'
        }}>
          {/* Company Logo */}
          <div style={{
            width: '64px',
            height: '64px',
            borderRadius: '12px',
            background: WALNUT,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            flexShrink: 0
          }}>
            <AppWindow size={30} strokeWidth={2} />
          </div>

          <div style={{ flex: 1 }}>
            <div style={{
              fontFamily: FONT_DISPLAY,
              fontSize: '18px',
              fontWeight: '600',
              color: INK,
              marginBottom: '4px'
            }}>
              The Window Place LLC
            </div>
            <div style={{
              fontSize: '13px',
              color: STONE
            }}>
              Professional Window & Door Installation
            </div>
          </div>
        </div>

        {/* Company Details */}
        <div style={{
          display: 'grid',
          gap: '12px'
        }}>
          <InfoRow label="Address" value="1300 E 4th Ave, Milbank, SD 57252" />
          <InfoRow label="Mailing" value="PO BOX 472, Milbank, SD 57252" />
          <InfoRow label="Office Phone" value="(605) 432-1834" />
          <InfoRow label="Fax" value="(605) 432-1837" />
          <InfoRow label="Text" value="(605) 401-2814" />
          <InfoRow label="Email" value="office@thewindowplacellc.com" />
          <InfoRow label="Website" value="thewindowplacellc.com" />
        </div>

        {/* Footer */}
        <div style={{
          marginTop: '20px',
          paddingTop: '16px',
          borderTop: '1px solid rgba(139,69,19,0.08)',
          textAlign: 'center',
          fontSize: '12px',
          color: STONE
        }}>
          © {currentYear} The Window Place LLC — All Rights Reserved
        </div>
      </div>
    </div>
  );
}

function InfoRow({ label, value }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 0',
      borderBottom: '1px solid rgba(139,69,19,0.06)'
    }}>
      <span style={{
        fontSize: '13px',
        fontWeight: '600',
        color: STONE
      }}>
        {label}
      </span>
      <span style={{
        fontSize: '13px',
        color: INK,
        textAlign: 'right'
      }}>
        {value}
      </span>
    </div>
  );
}
